// Shared options for the AI template analyzers (single-image path on the
// template form + the bulk draft creator).

// Audience tags an admin can assign to a template. Multiple may be selected
// (e.g. male + female for a unisex look). Drives the gallery gender filter and
// the "this template is for X" badge on the generate page.
export const GENDER_OPTIONS = [
    { value: 'male',     i18n: 'aiTemplateForm.genderMale' },
    { value: 'female',   i18n: 'aiTemplateForm.genderFemale' },
    { value: 'children', i18n: 'aiTemplateForm.genderChildren' },
    { value: 'product',  i18n: 'aiTemplateForm.genderProduct' },
];

// Field kinds the admin can ask the AI analyzer to create as dynamic fields
// (sent with analyze-image as guidance). Values are self-descriptive for the AI.
export const ANALYZE_FIELD_TYPE_OPTIONS = [
    { value: 'dress-change',      i18n: 'aiTemplateForm.ftDressChange' },
    { value: 'dress-color',       i18n: 'aiTemplateForm.ftDressColor' },
    { value: 'background-change', i18n: 'aiTemplateForm.ftBackgroundChange' },
    { value: 'background-color',  i18n: 'aiTemplateForm.ftBackgroundColor' },
    { value: 'hair-color',        i18n: 'aiTemplateForm.ftHairColor' },
    { value: 'pose',              i18n: 'aiTemplateForm.ftPose' },
    { value: 'expression',        i18n: 'aiTemplateForm.ftExpression' },
    { value: 'lighting',          i18n: 'aiTemplateForm.ftLighting' },
    { value: 'text',              i18n: 'aiTemplateForm.ftText' },
];
